import { Col, Form, Input, Row, Select } from "antd";
import ComposantsDeProjetFormItem from "../components/ComposantsDeProjetFormItem";
import UsageFormItem from "../components/UsageFormItem";
import ProgrammationSelect from "../components/ProgrammationSelect";

interface Props {
  form: any;
  typeDeProjet: string[];
}

interface Option {
  label: string;
  value: string;
}

export const PresentationProjetStep: React.FC<Props> = ({
  form,
  typeDeProjet,
}) => {
  
  return (
    <Row gutter={16} style={{ width: "100%" }} justify={"center"}>
      <Col md={12} lg={12} xs={24} sm={24}>
        <Form.Item
          name="promoteur"
          label="Promoteur / Aménageur"
          rules={[
            {
              required: true,
              message: "Veuillez saisir le promoteur / aménageur",
            },
          ]}
        >
          <Input />
        </Form.Item>
        <ComposantsDeProjetFormItem form={form} />
        {/* <Form.Item
          name="programmation"
          label="Programmation"
          rules={[
            {
              required: true,
              message: "Veuillez saisir la programmation",
            },
            {
              validator: (_, value) => {
                // Get the selected composants from the form
                const selectedTypes = form.getFieldValue("composants") || [];
                // If no composant is selected, you may choose to either skip validation
                // or force the user to select one (here we assume it's already required).
                for (let type of selectedTypes) {
                  // Get the valid programmation options for this composant
                  const validOptions = typeDeProjetOptions[type]?.map((opt) => opt.value) || [];
                  // Check if at least one valid option is selected in the programmation field
                  const hasValidOption = value?.some((val:any) => validOptions.includes(val));
                  if (!hasValidOption) {
                    return Promise.reject(
                      new Error(`Veuillez saisir au moins une programmation pour les ${type}`)
                    );
                  }
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <ProgrammationSelect  typeDeProjet={typeDeProjet} />
        </Form.Item> */}
        <UsageFormItem form={form} />
        <Form.Item
          name="type_de_standing"
          label="Type de standing"
          rules={[
            {
              required: true,
              message: "Veuillez saisir le type de standing",
            },
          ]}
        >
          <Select>
            <Select.Option value="economique">Économique</Select.Option>
            <Select.Option value="moyen standing">Moyen Standing</Select.Option>
            <Select.Option value="haut standing">Haut Standing</Select.Option>
            <Select.Option value="tres standing">Très Standing</Select.Option>
          </Select>
        </Form.Item>
      </Col>
    </Row>
  );
};
